@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
} @else {
	<app-setup-wizard-dynamic-table
		[enableEditButton]="enableEditButton()"
		[enableToggleDisableButton]="enableToggleDisableButton()"
		[enableRemoveButton]="enableRemoveButton()"
		[enableResetButton]="enableResetButton()"
		[selectedRow]="selectedRow()"
		[rows]="rows()"
		[pageSize]="pageSize()"
		[columns]="columns()"
		(onToggleDisable)="onToggleDisableClick($event)"
		(onRemove)="onRemoveClick($event)"
		(onReset)="onResetClick($event)"
		(onEdit)="onEditClick($event)"
	>
		<!-- Header templates (defines order/keys) -->
		<ng-template [appHeaderColumn]="ActivityCsvKeys.ssoActivityId">
			{{ ACTIVITY_CSV_LABELS[ActivityCsvKeys.ssoActivityId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ActivityCsvKeys.defaultLangId">
			{{ ACTIVITY_CSV_LABELS[ActivityCsvKeys.defaultLangId] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ActivityCsvKeys.displayOrder">
			{{ ACTIVITY_CSV_LABELS[ActivityCsvKeys.displayOrder] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ActivityCsvKeys.isInstruction">
			{{ ACTIVITY_CSV_LABELS[ActivityCsvKeys.isInstruction] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ActivityCsvKeys.enName">
			{{ ACTIVITY_CSV_LABELS[ActivityCsvKeys.enName] }}
		</ng-template>
		<ng-template [appHeaderColumn]="ActivityCsvKeys.active">
			{{ ACTIVITY_CSV_LABELS[ActivityCsvKeys.active] }}
		</ng-template>

		<ng-template appHeaderColumn="status">Status</ng-template>

		<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
		<ng-template [appRowColumn]="ActivityCsvKeys.ssoActivityId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ActivityCsvKeys.ssoActivityId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ActivityCsvKeys.defaultLangId" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ActivityCsvKeys.defaultLangId"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ActivityCsvKeys.displayOrder" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ActivityCsvKeys.displayOrder"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ActivityCsvKeys.isInstruction" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after
				[data]="row"
				[key]="ActivityCsvKeys.isInstruction"
			></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ActivityCsvKeys.enName" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="ActivityCsvKeys.enName"></app-setup-wizard-before-after>
		</ng-template>
		<ng-template [appRowColumn]="ActivityCsvKeys.active" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after [data]="row" [key]="ActivityCsvKeys.active"></app-setup-wizard-before-after>
		</ng-template>

		<ng-template appRowColumn="status" [rowType]="rowType" let-row>
			<app-setup-wizard-before-after-status [data]="row"></app-setup-wizard-before-after-status>
		</ng-template>
	</app-setup-wizard-dynamic-table>
}
